import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AdminApp from './AdminApp';
import UserApp from './UserApp';
import InternetModal from './modals/global/InternetModal/InternetModal';
import ScrollToTop from './components/errors/ScrollToTop';
import AppInstallBanner from './components/Buttons/AppInstallBanner';

import { AuthProvider } from './context/AuthContext';

function App() {
  return (
    <>
      <Router>
        <AuthProvider>
          <ScrollToTop />
          <Routes>
            <Route path="/*" element={<AdminApp />} />
          </Routes>
        </AuthProvider>
      </Router>
      <InternetModal />
      <AppInstallBanner /> {/* ✅ add banner here */}
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
    </>
  );
}

export default App;
